import { Colors } from '../../consts/Colors.js';
import QcmCheckA2 from './QcmCheckA2.js';
import ButtonImageSliced from '../ButtonImageSliced.js';
import QcmFeedbackA2 from './QcmFeedbackA2.js';
import { delay } from 'lodash';

export default class QcmA2 extends Phaser.GameObjects.Container {
    constructor(scene, questData, parent) {
        console.log("Create QCM A2", questData)
        super(scene, 200, 360, []);
        scene.add.existing(this);
        this.scene = scene;
        this.questData = questData;
        this.parent = parent;
        this.allReps = [];
        this.isRight = undefined;
        this.isFeedbackOn = false;
        this.screenContainer = this.scene.add.container(0, 0);
        this.add(this.screenContainer);

        this.questText = this.scene.createTextElement(1920, 0, this.questData.questText);
        this.screenContainer.add(this.questText)

        this.rep1 = new QcmCheckA2(this.scene, 35, 110, this.questData.repText1, this).setAlpha(0)
        this.screenContainer.add(this.rep1);
        this.allReps.push(this.rep1);

        this.rep2 = new QcmCheckA2(this.scene, 35, 215, this.questData.repText2, this).setAlpha(0)
        this.screenContainer.add(this.rep2);
        this.allReps.push(this.rep2);

        this.rep3 = new QcmCheckA2(this.scene, 35, 320, this.questData.repText3, this).setAlpha(0)
        this.screenContainer.add(this.rep3);
        this.allReps.push(this.rep3);

        this.validateBtn = new ButtonImageSliced(this.scene, 1510, 630, 200, 60, "bouton", "Valider").setAlpha(0)
        // this.validateBtn.setLocked()
        this.add(this.validateBtn)
        this.validateBtn.setClickFunction(() => {
            if (!this.isFeedbackOn) {
                this.scene.tweens.add({
                    targets: this.screenContainer,
                    x: 1920,
                    duration: 400,
                    ease: 'Power2',
                    onComplete: () => {
                        this.validateBtn.setTextContent("Suivant")
                        this.feedback = new QcmFeedbackA2(this.scene, this.questData.feedBackTrue, this.questData.feedBackImage, this.isRight)
                        // this.questText.destroy()
                        // this.rep1.destroy()
                        // this.rep2.destroy()
                        // this.rep3.destroy()
                        this.screenContainer.destroy()
                        this.isFeedbackOn = true
                    }
                })
            } else {
                this.validateBtn.destroy()
                this.scene.tweens.add({
                    targets: this.feedback.screenContainer,
                    x: 1920,
                    duration: 400,
                    ease: 'Power2',
                    onComplete: () => {
                        this.feedback.destroy()
                        this.parent.step = 1
                        this.parent.changeScreen();
                    }
                })
            }
        })

        this.scene.tweens.add({
            targets: this.questText,
            x: 0,
            duration: 400,
            ease: 'Power2',
            onComplete: () => {
                this.allReps.forEach((rep, index) => {
                    this.scene.tweens.add({
                        targets: rep,
                        alpha: 1,
                        duration: 400,
                        delay: index * 200,
                        ease: 'Power2',
                        onComplete: () => {
                            if (index === this.allReps.length - 1) {
                                this.scene.tweens.add({
                                    targets: this.validateBtn,
                                    alpha: 0.5,
                                    duration: 400,
                                    ease: 'Power2',
                                    onComplete: () => {
                                        this.validateBtn.setLocked()
                                        this.allReps.forEach(r => r.setCheckActif())
                                    }
                                })
                            }
                        }
                    })
                })
            }
        })
    }
}
